// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__kTF-U","errors":"Errors_errors__1NKPQ"};